
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private/chats",
      function () {
        return require("private-next-pages/private/chats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private/chats"])
      });
    }
  